import { ICompetitorsSnapshot } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

export const getEmptyRows = (count: number): ICompetitorsSnapshot[] => {
  const emptyItem: ICompetitorsSnapshot = {
    Name: '',
    YoY: null,
    HPSow: null,
  }
  return new Array(count).fill(emptyItem)
}
